<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Les Apprenants" />
            <LesApprenants />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import LesApprenants from './LesApprenants.vue';

export default {
    name: 'DisciplesPage',
    components: {
        NavBar,
        PageTitle,
        LesApprenants,
        FooterComp,
    }
}
</script>